module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/appSheetFirstImage-3b6680b2ef46e51539dcfa897c464ffe.png";